import apiConfig from '@constants/apiConfig';
import { accountActions, restaurantActions } from '@store/actions';
import { processAction } from '@store/utils';
import { takeLatest } from 'redux-saga/effects';

const getMyRestaurantSaga = (payload) => {
    let api = apiConfig.restaurant.getListCustomer;

    return processAction(api, payload);
};

const getDetailRestaurantSaga = (payload) => {
   
    let api = apiConfig.restaurant.getById;
    return processAction(api, payload);
};

const sagas = [
    takeLatest(restaurantActions.getMyRestaurant.type, getMyRestaurantSaga),
    takeLatest(restaurantActions.getDetailRestaurant.type, getDetailRestaurantSaga),
];

export default sagas;
